import {
  AnalysisHistoryEntry,
  AnalysisHistoryResult,
} from '../../application/entities/analysis-history.entity';
import {
  AnalysisHistoryEntryDto,
  AnalysisHistoryResponseDto,
} from '../dto/analysis-history-response.dto';

export const toAnalysisHistoryEntry = (dto: AnalysisHistoryEntryDto): AnalysisHistoryEntry => ({
  id: dto.uuid,
  occurredAt: new Date(dto.occurredAt),
  actorName: dto.actorName ?? null,
  actorRole: dto.actorRole ?? null,
  action: dto.action,
  entityType: dto.entityType,
  entityUuid: dto.entityUuid ?? null,
  entityLabel: dto.entityLabel ?? null,
  // El backend omite (NON_NULL) los campos vacíos: se normalizan a null/[].
  changes: (dto.changes ?? []).map((c) => ({
    field: c.field,
    oldValue: c.oldValue ?? null,
    newValue: c.newValue ?? null,
  })),
  comment: dto.comment ?? null,
});

export const toAnalysisHistoryResult = (
  dto: AnalysisHistoryResponseDto,
  init: number,
  limit: number,
): AnalysisHistoryResult => {
  const paging = dto.metadata?.paging;
  return {
    items: (dto.data?.history ?? []).map(toAnalysisHistoryEntry),
    paging: {
      init,
      limit,
      total: paging?.total ?? 0,
      totalPages: paging?.totalPages ?? 0,
    },
  };
};
